import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-OutdoorMediaF",
  "use": "svg-icon-OutdoorMediaF-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-OutdoorMediaF\"><path d=\"M14 12h-2v2H4v-2H2v4h12v-4zm0-10V0H2v2h12zM2 3h12v8H2V3zm2 2v4h8V5H4z\" fill=\"#FFF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol